import { ItemsInicio } from './items-inicio';

export class ItemsEcCat {
  itemsEC_Cat1?: ItemsInicio;
  itemsEC_Cat2?: ItemsInicio;
  itemsEC_Cat3?: ItemsInicio;

  constructor(
    itemsEC_Cat1?: ItemsInicio,
    itemsEC_Cat2?: ItemsInicio,
    itemsEC_Cat3?: ItemsInicio
  ) {
    this.itemsEC_Cat1 = itemsEC_Cat1;
    this.itemsEC_Cat2 = itemsEC_Cat2;
    this.itemsEC_Cat3 = itemsEC_Cat3;
  }
}
